import { useNavigate } from "react-router-dom";

function ExpiryPopUp({ setExpirePopupVisibility, navigation }) {
  const navigate = useNavigate();
  const handleClose = () => {
    if (navigation) {
      navigate(-1);
    } else {
      setExpirePopupVisibility(false);
    }
  };
  return (
    <div className="main-popup">
      <div className="confirm-main-box rounded d-flex flex-column">
        <div className="invitation-header-title d-flex flex-column align-items-center justify-content-center">
          <p className="expiry-btn-txt">
            Your credit has been expired. Please contact InCruiter
          </p>
        </div>

        <div className="d-flex justify-content-center align-items-center mt-3 mb-4 gap-10">
          <button
            className="expiry-btn f-16 cpp-btn f-sem-bol common-btn invite_btn linkBtn w-15"
            onClick={handleClose}
          >
            Okay
          </button>
        </div>
      </div>
    </div>
  );
}

export default ExpiryPopUp;
